export default __webpack_public_path__ + "static/media/discord.5d7f43bc.svg";